import {
  cancelSubscriptionAtPeriodEnd as cancelSubscriptionAtPeriodEndCallable,
  type CancelSubscriptionAtPeriodEndResponse,
} from '@/core/services/payments/payment-functions.service';

/**
 * Chama a Cloud Function `cancelStripeSubscriptionAtPeriodEnd` (cancelamento ao fim do período).
 */
export class CancelSubscriptionUseCase {
  async execute(): Promise<CancelSubscriptionAtPeriodEndResponse> {
    return cancelSubscriptionAtPeriodEndCallable();
  }
}
